export const UserRoles = {
  SUPER_ADMIN: "SUPER_ADMIN",
  COORDINATOR: "COORDINATOR",
  SUPER_USER: "SUPER_USER",
  EDITOR: "EDITOR",
  AUDITOR: "AUDITOR",
  CONTRIBUTOR: "CONTRIBUTOR",

  USER_ROLES: ["EDITOR", "CONTRIBUTOR", "AUDITOR"],
  FULL_ACCESS_ROLES: ["SUPER_ADMIN", "COORDINATOR"],
};
